import { createStyles, Theme } from '@material-ui/core'
import { RichTextEditorProps } from './richTextEditor.model'

export const richTextEditorStyle = (theme: Theme) =>
  createStyles({
    quillEditor: {
      width: '100%',
      minHeight: 0,
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      '& .ql-toolbar': { flex: '0 0 auto' },
      '& .ql-container': { flex: '1 1 auto', minHeight: 0, height: 'auto' },
      '& .ql-editor': { overflowY: 'auto' },
      '& .ql-blog-view': {
        width: 'auto !important',
        padding: '0 8px !important',
        fontSize: 13
      }
    },
    markdownQuill: {
      flex: '0 0 auto',
      '& .ql-toolbar .ql-formats:not(:last-child)': { display: 'none' },
      '& .ql-container': { display: 'none' }
    },
    markdownInput: {
      boxSizing: 'border-box',
      flex: '1 1 auto',
      width: '100%',
      minHeight: 0,
      padding: theme.spacing(2),
      border: '1px solid #ccc',
      borderTop: 0,
      borderRadius: 0,
      resize: 'vertical',
      fontFamily: 'monospace',
      fontSize: 14,
      lineHeight: 1.5
    },
    container: {
      height: (props: RichTextEditorProps) => props.height || '350px',
      paddingBottom: theme.spacing(3),
      marginBottom: theme.spacing(2),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 200
    }
  })
